import { apiServer } from 'settings/web-services/api';

export function getPendingInvites() {
  return apiServer.get('/user/client/pending-invites');
}

export function updateInviteStatus(cfg) {
  return apiServer.post(`/user/client/update-invite`, cfg);
}
